/*
 * @Author: Teemo Ding
 * @Date: 2021-07-07 16:41:24
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-07 16:41:55
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Order/config.tsx
 */
const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('general.storeCommunicationSetting.order'),
  },
];
export { breadcrumbData };
